import React from 'react'
import convertUnit from 'lib/unit'
import {RoboyuColorTheme} from '../../../types'
import {RoboyuAssetProps} from './RoboyuAssetProps'

export default function RoboyuHappy({
  width = convertUnit(519),
  height = convertUnit(673),
  colorTheme = 'blue',
  ...props
}: RoboyuAssetProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 2000 2000"
      fill="none">
      <g filter="url(#filter0_d_4220_33897)">
        <path
          d="M702.922 274.5H356V521.7H702.922V274.5Z"
          fill={RoboyuColorTheme[colorTheme].emoji_3}
        />
        <path
          d="M663.557 561.225V235L395.373 235V561.225H663.557Z"
          fill={RoboyuColorTheme[colorTheme].emoji_1}
        />
        <path
          d="M460.971 447.488H495.887V473.558H565.607V447.488H600.524V503.952H460.971V447.488Z"
          fill={RoboyuColorTheme[colorTheme].emoji_eye_mouth}
        />
        <path
          d="M579.932 406.524V274.949H439.224V406.524H579.932Z"
          fill={RoboyuColorTheme[colorTheme].emoji_2}
        />
        <path
          d="M466.236 346.629H436.36H406.086V377.004V407.979H436.36V377.004H466.236V407.979H496.535V377.004V346.629H466.236Z"
          fill={RoboyuColorTheme[colorTheme].emoji_eye_mouth}
        />
        <path
          d="M622.564 346.629H592.688H562.414V377.004V407.979H592.688V377.004H622.564V407.979H652.838V377.004V346.629H622.564Z"
          fill={RoboyuColorTheme[colorTheme].emoji_eye_mouth}
        />
        <path
          d="M765.958 576.027H713.009C706.583 576.027 701.373 581.254 701.373 587.702V640.827C701.373 647.275 706.583 652.502 713.009 652.502H765.958C772.385 652.502 777.595 647.275 777.595 640.827V587.702C777.595 581.254 772.385 576.027 765.958 576.027Z"
          fill={RoboyuColorTheme[colorTheme].emoji_1}
        />
        <path
          d="M820.977 1436.15C840.138 1300.5 958.345 1255.25 1093.55 1274.48C1228.75 1293.7 1329.74 1370.15 1310.57 1505.78C1291.41 1641.4 1159.6 1783.28 1024.4 1763.93C889.2 1744.58 801.815 1571.8 820.977 1436.15Z"
          fill="white"
        />
        <path
          d="M1292.21 1388.64C1265.47 1446.99 1188.63 1500.37 1011.14 1476.64C904.001 1462.29 852.971 1429.14 831.542 1392.52C826.554 1406.66 823.014 1421.28 820.977 1436.14C801.816 1571.79 889.175 1744.69 1024.38 1763.92C1159.58 1783.14 1291.39 1641.42 1310.55 1505.77C1317.03 1459.99 1309.8 1420.99 1292.21 1388.64Z"
          fill="#98B1DC"
        />
        <path
          d="M904.778 1463.34C916.613 1379.57 991.988 1360.24 1079.65 1372.72C1167.31 1385.19 1234.36 1424.74 1222.52 1508.52C1210.69 1592.29 1129.95 1649.99 1042.22 1637.62C954.488 1625.24 892.942 1547.12 904.778 1463.34Z"
          fill="#BDE5EE"
        />
        <path
          d="M905.148 1460.75C916.71 1378.9 991.91 1360.25 1079.57 1372.72C1167.23 1385.2 1234.38 1424.07 1222.82 1505.92C1211.26 1587.77 1130.62 1644 1043.01 1631.52C955.406 1619.05 893.587 1542.5 905.148 1460.75Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M916.142 1463.64C926.906 1387.57 996.799 1370.22 1078.35 1381.82C1159.91 1393.42 1222.27 1429.57 1211.53 1505.64C1200.8 1581.72 1125.94 1634.02 1044.37 1622.49C962.787 1610.97 905.402 1539.72 916.142 1463.64Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1211.28 1472.24C1201.86 1418.67 1146.92 1391.57 1078.35 1381.82C996.794 1370.22 926.901 1387.57 916.137 1463.64C914.793 1473.14 914.5 1482.76 915.265 1492.32C933.629 1503.17 956.951 1512.97 986.478 1520.99C1095.42 1550.62 1172.46 1519.02 1211.28 1472.24Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M1159.08 1467.27L1142.54 1464.92L1144.78 1448.95L1112.07 1444.27L1109.82 1460.27L1092.16 1457.75L1090.24 1471.3L1076.91 1469.42L1074.96 1483.27L1064.4 1481.77L1054.66 1480.4L1056.65 1466.22L1042.22 1464.17L1044.12 1450.67L1024.78 1447.92L1026.87 1433.12L994.157 1428.47L992.064 1443.27L977.189 1441.15L969.539 1495.3L988.127 1497.95L984.141 1526.17L1017.31 1530.9L1014.19 1552.97L1037.14 1556.25L1035.02 1571.17L1067.74 1575.82L1069.86 1560.9L1092.31 1564.07L1095.42 1542L1129.18 1546.82L1133.15 1518.82L1151.43 1521.42L1159.08 1467.27Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1158.34 1467.15L1142.61 1464.93L1144.86 1448.95L1112.14 1444.28L1109.9 1460.28L1092.23 1457.78L1090.31 1471.33L1076.98 1469.45L1075.01 1483.3L1064.47 1481.8L1054.73 1480.43L1056.72 1466.25L1042.3 1464.2L1044.19 1450.7L1024.86 1447.95L1026.95 1433.15L994.232 1428.5L992.139 1443.3L977.189 1441.18L969.539 1495.33L988.127 1497.98L986.657 1508.53C994.681 1511.55 1003.43 1514.48 1012.94 1517.23C1082.41 1537.33 1128.71 1506.03 1158.34 1467.15Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M1022.24 1747.75C958.376 1738.2 912.803 1707.15 880.211 1667.75C916.067 1718.37 965.727 1755.65 1024.38 1764C1101.18 1774.92 1176.87 1734 1231.44 1671.5C1183.25 1722.3 1114.93 1761.62 1022.24 1747.75Z"
          fill="#BDE5EE"
        />
        <path
          d="M1064.57 575.404C1064.57 575.404 1032.73 376.629 1049.3 370.404C1065.87 364.179 1144.71 384.804 1144.71 384.804C1144.71 384.804 1198.58 272.829 1203.84 278.729C1209.09 284.629 1238.92 469.279 1231.25 475.029C1223.57 480.779 1125.95 477.904 1125.95 477.904C1125.95 477.904 1067.17 598.579 1064.57 575.404Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_2}
        />
        <path
          d="M1561.77 1049.75C1577.49 1307.5 1359.71 1321.33 1091.06 1337.85C822.4 1354.38 604.499 1367.5 588.777 1109.53C573.054 851.553 778.147 629.253 1046.78 612.753C1315.41 596.253 1546.02 791.903 1561.77 1049.75Z"
          fill="white"
        />
        <path
          d="M1091.05 1337.86C1359.71 1321.33 1577.49 1307.51 1561.77 1049.76C1560.8 1034.12 1559.03 1018.54 1556.46 1003.08C1470.57 1113.33 1256.18 1278.26 862.515 1256.73C742.912 1250.18 660.686 1227.68 604.871 1196.98C662.081 1363.91 857.307 1352.21 1091.05 1337.86Z"
          fill="#98B1DC"
        />
        <path
          d="M1487.24 1043.45C1500.75 1264.42 1315.96 1276.07 1088.02 1290.1C860.078 1304.12 675.242 1315.1 661.762 1094.17C648.282 873.249 827.137 764.699 1055.1 750.699C1283.07 736.699 1473.86 822.499 1487.24 1043.45Z"
          fill="#BDE5EE"
        />
        <path
          d="M1487.24 1040.27C1500.57 1259.04 1315.81 1270.69 1087.84 1284.69C859.872 1298.69 675.087 1309.69 661.756 1090.97C648.425 872.244 827.331 764.694 1055.3 750.694C1283.27 736.694 1473.81 821.494 1487.24 1040.27Z"
          fill={RoboyuColorTheme[colorTheme].face_body_outline}
        />
        <path
          d="M1472.86 1042.84C1485.7 1252.84 1307.37 1264.19 1087.35 1277.69C867.328 1291.19 688.971 1301.89 676.213 1091.79C663.456 881.694 836.057 778.394 1056.18 764.994C1276.29 751.594 1460.06 832.769 1472.86 1042.84Z"
          fill={RoboyuColorTheme[colorTheme].face_body_2}
        />
        <path
          d="M1462.6 978.134C1419.12 816.009 1251.85 752.859 1056.18 765.009C836.182 778.534 663.456 881.834 676.289 1091.93C677.153 1107.43 679.202 1122.83 682.418 1138.01C724.478 1184.06 798.507 1219.13 923.816 1226.31C1227.83 1243.71 1392.83 1095.76 1462.6 978.134Z"
          fill={RoboyuColorTheme[colorTheme].face_body_1}
        />
        <path
          d="M859.628 928.368C814.777 931.118 781.537 982.718 785.275 1043.59C789.013 1104.47 825.142 1088.59 869.993 1085.84C914.844 1083.09 951.198 1094.52 947.486 1033.64C943.773 972.768 904.404 925.618 859.628 928.368Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1250.93 904.349C1206.07 907.099 1172.86 958.674 1176.57 1019.57C1180.28 1080.47 1216.44 1064.57 1261.29 1061.82C1306.14 1059.07 1342.5 1070.5 1338.78 1009.6C1335.07 948.699 1295.7 901.599 1250.93 904.349Z"
          fill={RoboyuColorTheme[colorTheme].eyes}
        />
        <path
          d="M1144.7 384.672C1144.7 384.672 1065.89 363.922 1049.29 370.272C1032.7 376.622 1064.57 575.397 1064.57 575.397C1067.63 576.322 1107.7 429.297 1110.31 429.447C1112.93 429.597 1191.2 433.247 1192.72 429.447C1194.24 425.647 1205.72 290.572 1203.83 278.647C1198.57 272.697 1144.7 384.672 1144.7 384.672Z"
          fill={RoboyuColorTheme[colorTheme].heart_hair_1}
        />
        <path
          d="M776.825 1503.48C827.208 1525.51 815.447 1359.03 809.741 1338.13C804.035 1317.23 531.267 1151.81 481.881 1170.01C432.495 1188.21 571.259 1413.61 776.825 1503.48Z"
          fill="white"
        />
        <path
          d="M481.878 1170.01C480.046 1170.66 478.371 1171.69 476.963 1173.04C475.555 1174.38 474.445 1176.01 473.705 1177.81C479.959 1219.41 651.19 1402.51 811.981 1459.46C818.609 1414.46 813.077 1350.56 809.688 1338.13C804.032 1317.21 531.264 1151.81 481.878 1170.01Z"
          fill="#98B1DC"
        />
        <path
          d="M798.505 1334.77C803.912 1339.5 813.456 1383.7 813.705 1444.77C817.542 1401.55 812.783 1349.12 809.743 1338C804.51 1319.05 577.365 1180 499.873 1169.2C572.382 1190.12 676.361 1242.67 798.505 1334.77Z"
          fill="#BDE5EE"
        />
        <path
          d="M1363.55 1504.44C1315.31 1530.77 1312.65 1363.89 1316.51 1342.49C1320.37 1321.09 1577.86 1132.69 1628.65 1146.44C1679.43 1160.19 1560.6 1397.07 1363.55 1504.44Z"
          fill="white"
        />
        <path
          d="M1628.64 1146.53C1630.53 1147.02 1632.28 1147.9 1633.8 1149.12C1635.32 1150.34 1636.56 1151.87 1637.44 1153.6C1634.95 1195.68 1480.01 1393.03 1324.7 1463.6C1314.19 1419.23 1314.21 1355.18 1316.51 1342.53C1320.29 1321.23 1577.86 1132.78 1628.64 1146.53Z"
          fill="#98B1DC"
        />
        <path
          d="M1327.42 1338.27C1322.43 1343.42 1316.63 1388.27 1321.76 1449.3C1314.29 1406.55 1314.44 1353.92 1316.5 1342.57C1320.04 1323.12 1534.38 1164.78 1610.68 1147.38C1540.23 1174.53 1441.16 1235.9 1327.42 1338.27Z"
          fill="#BDE5EE"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4220_33897"
          x="318.759"
          y="201.483"
          width="1358.86"
          height="1605.24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.72414" />
          <feGaussianBlur stdDeviation="18.6207" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0 0.3375 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4220_33897"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4220_33897"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
